import React from 'react';
import { Container } from 'reactstrap';
import AdminHeader from 'components/organisms/adminHeader';
import AdminUserEditBlock from 'components/templates/admin/userEdit';

const AdminUserEdit = () => (
  <Container>
    <AdminHeader />
    <AdminUserEditBlock />
  </Container>
);

export default AdminUserEdit;
